import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { WeeksSection } from '../components/WeeksSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { IncludesSection } from '../components/IncludesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream font-body text-navy selection:bg-sage selection:text-white" data-id="element-150">
      <Navbar data-id="element-151" />
      <HeroSection data-id="element-152" />
      <PainSection data-id="element-153" />
      <SolutionSection data-id="element-154" />
      <WeeksSection data-id="element-155" />
      <ForWhoSection data-id="element-156" />
      <IncludesSection data-id="element-157" />
      <TestimonialsSection data-id="element-158" />
      <FAQSection data-id="element-159" />
      <CTASection data-id="element-160" />
      <FooterSection data-id="element-161" />
    </div>;
}